module.exports = __webpack_public_path__ + "static/cot1lawn-60115a2db9c115c7bf8f14ee1ea93cbe.jpg";